$(window).load(function () {
  var characters = /[,.~\s]/g;

  $('#FileDescription').keyup(function () {
    $('#documents-file-description-rem').html(this.value.length + ' of 100');
  });

  $('#documents-folder-name').keyup(function () {
    $('#documents-folder-name-rem').html(this.value.length + ' of 100');
  });

  $('#FileDescription').keyup(function (e) {
    var text = $(this).val();
    if (e.which == 192 || e.which == 190 || e.which == 32 || e.which == 188) {
      $('#FileDescription').val(text.replace(characters, ''));
    }
    $('#documents-file-description-rem').html(this.value.length + ' of 100');
  });

  $('#FileDescription').on('paste', function (e) {
    var text = $(this);
    setTimeout(function () {
      var pastedText = text.val();
      $('#FileDescription').val(pastedText.replace(characters, ''));
      var textLength = text.val();
      $('#documents-file-description-rem').html(textLength.length + ' of 100');
    });
  });

  $('#NewFolder').keyup(function (e) {
    var text = $(this).val();
    if (e.which == 192 || e.which == 190 || e.which == 32 || e.which == 188) {
      $('#NewFolder').val(text.replace(characters, ''));
    }
    $('#documents-folder-name-rem').html(this.value.length + ' of 100');
  });

  $('#NewFolder').on('paste', function (e) {
    var text = $(this);
    setTimeout(function () {
      var pastedText = text.val();
      $('#NewFolder').val(pastedText.replace(characters, ''));
      var textLength = text.val();
      $('#documents-folder-name-rem').html(textLength.length + ' of 100');
    });
  });
});

function setIssueDetailKey(e) {
  var target = e.target;
  var targetParent = $(e.target).parent().parent();
  var remValues = $(targetParent).find($('p'));
  remValues[0].innerText = target.value.length + ' of 500';
}

function setIssueCloseClick(e) {
  var target = e.target;
  var caseBox = $(e.target).closest('.case-desc')[0];
  caseBox.remove();

  var caseContent = $('#warranty-case-content');
  var caseBoxes = caseContent.find($('.case-desc'));
  var caseNames = caseBoxes.find($('.case-issue-name'));
  var count = $('.case-count')[0];

  var i;
  for (i = 0; i < caseNames.length; i++) {
    caseNames[i].innerText = 'Item ' + (i + 1);
  }
  count.value = (parseInt(count.value) - 1);
}

//NUMBER VALIDATION
function isKeyNumber(e) {
  if ((e.which < 48 || e.which > 57) && e.which != 127) {
    e.preventDefault();
  }
}

//PHONE VALIDATIONS
var zChar = new Array(' ', '(', ')', '-', '.');
var maxphonelength = 13;
var phonevalue1;
var phonevalue2;
var cursorposition;
var keycode;

function isValidPhone(key, object, e) {
  if (e) e = e;
  else e = window.event;

  if (e.which) keycode = e.which;
  else keycode = e.keyCode;

  if (key == 'keyUp') {
    phonevalue1 = ParseChar(object.value, zChar);
    if (keycode >= 48) ValidatePhone(object);
  } else phonevalue2 = ParseChar(object.value, zChar);
}


function GetCursorPosition() {
  var t1 = phonevalue1;
  var t2 = phonevalue2;
  var bool = false;
  for (i = 0; i < t1.length; i++) {
    if (t1.substring(i, 1) != t2.substring(i, 1)) {
      if (!bool) {
        cursorposition = i;
        bool = true;
      }
    }
  }
}

function ValidatePhone(object) {
  var p = phonevalue1;
  p = p.replace(/[^\d]*/gi, '');

  if (p.length < 3) object.value = p;
  else if (p.length == 3) {
    pp = p;
    d4 = p.indexOf('(');
    d5 = p.indexOf(')');
    if (d4 == -1) pp = '(' + pp;
    if (d5 == -1) pp = pp + ')';
    object.value = pp;
  } else if (p.length > 3 && p.length < 7) {
    p = '(' + p;
    l30 = p.length;
    p30 = p.substring(0, 4);
    p30 = p30 + ')';

    p31 = p.substring(4, l30);
    pp = p30 + p31;

    object.value = pp;
  } else if (p.length >= 7) {
    p = '(' + p;
    l30 = p.length;
    p30 = p.substring(0, 4);
    p30 = p30 + ')';

    p31 = p.substring(4, l30);
    pp = p30 + p31;

    l40 = pp.length;
    p40 = pp.substring(0, 8);
    p40 = p40 + '-';

    p41 = pp.substring(8, l40);
    ppp = p40 + p41;

    object.value = ppp.substring(0, maxphonelength);
  }

  GetCursorPosition();
  if (cursorposition >= 0) {
    if (cursorposition == 0) cursorposition = 2;
    else if (cursorposition <= 2) cursorposition = cursorposition + 1;
    else if (cursorposition <= 5) cursorposition = cursorposition + 2;
    else if (cursorposition == 6) cursorposition = cursorposition + 2;
    else if (cursorposition == 7) {
      cursorposition = cursorposition + 4;
      e1 = object.value.indexOf(')');
      e2 = object.value.indexOf('-');
      if (e1 > -1 && e2 > -1) {
        if (e2 - e1 == 4) cursorposition = cursorposition - 1;
      }
    } else if (cursorposition < 11) cursorposition = cursorposition + 3;
    else if (cursorposition == 11) cursorposition = cursorposition + 1;
    else if (cursorposition >= 12) cursorposition = cursorposition;

    /*
    var txtRange = object.createTextRange();
    txtRange.moveStart('character', cursorposition);
    txtRange.moveEnd('character', cursorposition - object.value.length);
    txtRange.select();
    */
  }
}

function ParseChar(sStr, sChar) {
  if (sChar.length == null) zChar = new Array(sChar);
  else zChar = sChar;

  for (i = 0; i < zChar.length; i++) {
    sNewStr = '';
    var iStart = 0;
    var iEnd = sStr.indexOf(sChar[i]);

    while (iEnd != -1) {
      sNewStr += sStr.substring(iStart, iEnd);
      iStart = iEnd + 1;
      iEnd = sStr.indexOf(sChar[i], iStart);
    }
    sNewStr += sStr.substring(sStr.lastIndexOf(sChar[i]) + 1, sStr.length);
    sStr = sNewStr;
  }
  return sNewStr;
}